import axiosInstance from '../services/AxiosInstance';

export const getMerchantSettings = async () => {
  const response = await axiosInstance.get("common-merchant-settings");
  return response.data;
};

export const saveMerchantSettings = async (data) => {
  const response = await axiosInstance.put("common-merchant-settings/1", data);
  return response.data;
};